<template>
  <div class="ProjectEdit__part">
    <violet-bar>Intervenants</violet-bar>
    <help-message>
      <h3 slot="title">Intervenants</h3>
      <p>
        Ce tableau concerne les différents interlocuteurs du projet.<br />
        Le <strong>rôle</strong> désigne le rôle de l'entreprise dans le
        projet.<br />
        Le <strong>statut</strong> désigne la qualité du
        <strong>contact</strong> lors de ce projet, et non son métier.<br />
        Par exemple, <strong>Friedrich N.</strong>, travaillant en tant
        qu'<strong>Architecte</strong> (son métier) chez
        <strong>Void Architecture</strong>, peut avoir comme Statut
        <strong>"Chef de projet"</strong> lors de ce projet particulier.<br />
        Une ligne doit être intégralement remplie, ou elle disparaît à
        l'enregistrement. <br /><br />
        <strong
          >Si deux contacts partagent un rôle similaire lors d'un projet,
          ajoutez une ligne pour le second.</strong
        ><br />
        <strong
          >Si vous ajoutez un nouveau contact, spécifiez d'abord son entreprise
          : les deux seront liés automatiquement.</strong
        >
      </p>
    </help-message>
    <div
      class="Interlocuteurs Interlocuteurs__table"
      :class="
        open ? 'Interlocuteurs__table__open' : 'Interlocuteurs__table__closed'
      "
    >
      <table
        class="is-small is-size-7 is-fullwidth is-striped is-hoverable table is-bordered"
      >
        <thead>
          <tr>
            <td>Rôle</td>
            <td>Entreprise</td>
            <td>Contact</td>
            <td>Statut du contact</td>
            <td>Suppr.</td>
          </tr>
        </thead>
        <tbody>
          <InterlocuteurRow
            v-for="(inter, index) in project.interlocuteurs"
            :key="index"
            :interlocuteur="inter"
            @remove="remove(index)"
            @update="update($event.key, index, $event.val)"
          />
        </tbody>
      </table>
      <div
        class="Interlocuteurs__table__expand"
        v-if="project.interlocuteurs.length > 14"
      >
        <span class="button" @click="open = !open" v-if="!open"
          >Afficher les lignes restantes</span
        >
        <span class="button" @click="open = !open" v-else
          >Compresser l'affichage</span
        >
      </div>
    </div>
    <div class="buttons">
      <button class="button" @click="addRow">Ajouter une ligne</button>
    </div>
  </div>
</template>
<script>
import VioletBar from "../VioletBar";
import {
  remapInterlocuteurToIds,
  DefaultSparseInterlocuteur
} from "../../../store/models/project";
import { cheapoClone } from "../../../util/func";
import InterlocuteurRow from "../../../components/Form/InterlocuteurRow";
import HelpMessage from "../../../components/Form/HelpMessage";

export default {
  name: "ProjectEdit-Interlocuteurs",
  components: { HelpMessage, InterlocuteurRow, VioletBar },
  props: {
    item: {}
  },
  data() {
    return {
      open: false
    };
  },
  computed: {
    project: {
      get() {
        return this.item;
      },
      set(val) {
        this.$emit("update", val);
      }
    }
  },
  methods: {
    update(key, index, value) {
      const p = cheapoClone(this.project);
      p.interlocuteurs[index][key] = value;
      this.project = p;
    },
    addRow() {
      const p = cheapoClone(this.project);
      p.interlocuteurs.push(
        remapInterlocuteurToIds(DefaultSparseInterlocuteur(this.project.id))
      );
      this.project = p;
    },
    remove(index) {
      const p = cheapoClone(this.project);
      p.interlocuteurs = p.interlocuteurs.filter((a, i) => i !== index);
      this.project = p;
    }
  }
};
</script>

<style lang="scss">
.Interlocuteurs__table {
  max-height: 600px;
  overflow: hidden;
  margin-bottom: 1em;
  position: relative;
  &__open {
    max-height: none;
    padding-bottom: 2em;
    .Interlocuteurs__table__expand {
      background: none;
      padding-top: 1em;
    }
  }
  &__expand {
    background: linear-gradient(to top, white 50%, transparent 100%);
    padding: 3em;
    padding-bottom: 1em;
    text-align: center;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 1;
  }
}
</style>
